var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"tienda"}},[_c('v-row',_vm._l((_vm.products),function(product){return _c('pricing-card',{key:product.id,attrs:{"value":product}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }